document.addEventListener("DOMContentLoaded", function () {
  const tabHeads = document.querySelectorAll(".tab-head");
  const tabContents = document.querySelectorAll(".tab-content");
  const tabContainer = document.querySelector(".tab-contents");
  const tabHeadsContainer = document.querySelector(".tab-heads");

  // URLを更新する関数
  function updateURL(tabId) {
    if (history.pushState) {
      // URLのハッシュ部分を更新
      history.pushState(null, null, `#${tabId}`);
    } else {
      // 古いブラウザ用のフォールバック
      location.hash = `#${tabId}`;
    }
  }

  // タブをアクティブ化する関数
  function activateTab(tabId) {
    const targetHead = document.querySelector(`.tab-head[data-tab="${tabId}"]`);
    const targetContent = document.getElementById(tabId);

    if (targetHead && targetContent) {
      // すべてのタブを非アクティブ化
      tabHeads.forEach((h) => h.classList.remove("active"));
      tabContents.forEach((c) => c.classList.remove("active"));

      // 対象のタブをアクティブ化
      targetHead.classList.add("active");
      targetContent.classList.add("active");
    }
  }

  // ページ上部にスクロールする関数
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  // 画面幅に応じた動作を切り替える関数
  function handleResponsiveTabs() {
    const isSP = window.innerWidth <= 768; // SP版の判定

    // タブクリック時の動作
    tabHeads.forEach((head) => {
      head.addEventListener("click", function () {
        const targetTabId = this.getAttribute("data-tab");

        activateTab(targetTabId);

        if (isSP) {
          // SP版: タブ一覧を非表示にしてコンテンツを表示
          tabHeadsContainer.classList.add("hidden");
          tabContainer.classList.add("active");

          // ページ上部にスクロール
          scrollToTop();
        } else {
          // PC版: ページ上部にスクロール
          scrollToTop();
        }

        // URLを更新
        updateURL(targetTabId);
      });
    });

    // SP版: 「ご利用ガイドに戻る」ボタンの動作
    if (isSP) {
      const backButtons = document.querySelectorAll(".back-to-guide");
      backButtons.forEach((button) => {
        button.addEventListener("click", function () {
          // コンテンツを非表示にしてタブ一覧を再表示
          tabContainer.classList.remove("active");
          tabHeadsContainer.classList.remove("hidden");

          // ページ上部にスクロール
          scrollToTop();
        });
      });
    }
  }

  // ページ読み込み時にハッシュ値を確認してタブを切り替え
  function handleHashOnLoad() {
    const hash = window.location.hash;
    if (hash) {
      const targetTab = hash.replace("#", ""); // ハッシュ値からIDを取得
      activateTab(targetTab);

      // SP版の場合、該当タブまでスクロールし、レイアウトを変更
      const isSP = window.innerWidth <= 768;
      if (isSP) {
        const targetContent = document.getElementById(targetTab);
        if (targetContent) {
          // タブ一覧を非表示にしてコンテンツを表示
          tabHeadsContainer.classList.add("hidden");
          tabContainer.classList.add("active");
        }
      }

      // ページ上部にスクロール
      // ブラウザによってloadイベントタイミングが異なるため一定時間待機
      setTimeout(() => {
        window.scrollTo({ top: 0 });
      }, 50);
    }
  }

  // 内部リンクでタブを切り替え
  document.querySelectorAll("a[href^='#']").forEach((link) => {
    link.addEventListener("click", function (e) {
      const targetTab = this.getAttribute("href").replace("#", "");
      activateTab(targetTab);

      // URLを更新
      updateURL(targetTab);

      // SP版: ページ上部にスクロール
      const isSP = window.innerWidth <= 768;
      if (isSP) {
        scrollToTop();
      } else {
        // PC版: ページ上部にスクロール
        scrollToTop();
      }

      e.preventDefault(); // デフォルトのリンク動作を無効化
    });
  });

  // リンクでタブを切り替えた場合にページ上部に移動
  window.addEventListener("load", handleHashOnLoad);

  // 初期化
  handleResponsiveTabs();

  // 画面幅が変更されたときに再判定
  window.addEventListener("resize", handleResponsiveTabs);
});
